import Cookies from 'js-cookie';

const SET_LANGUAGE = 'SET_LANGUAGE';

export const setLanguage = (lang) => ({
    type: SET_LANGUAGE,
    payload: lang
});

const getInitialLocale = () => {
    const saved = Cookies.get('locale');
    return saved || 'id';
};

const initialState = {
    locale: getInitialLocale()
};

const appReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_LANGUAGE:
            return { ...state, locale: action.payload };
        default:
            return state;
    }
};

export default appReducer;
